import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: "root"
})
export class SnackbarService {
    constructor(private snackBar: MatSnackBar) {}

    public showMessage(message: string, duration = 5000, isError = false): void {
        this.snackBar.open(message, "OK", {
            duration: isError ? 0 : duration,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: isError ? "msg-error" : null
        });
    }

    public showHttpMessage(statusCode: number, message: string, hide401 = true, hide404 = true) {
        if (hide401 && statusCode == 401) return;
        if (hide404 && statusCode == 404) return;

        this.snackBar.open(`${statusCode} - ${message}`, "x", { duration: 5000, panelClass: "mat-primary" });
    }
}
